import { ApiResponse } from "../../../types";
import { OtpPayload, OtpResponse, LoginBody, Login, CheckAuthResponse, AuthError, RegisterResponse, RegisterUserBody, ResendOtpResponse, ResendOtpPayload, ResendOtp } from "../../../types/login.types";
import { getRequestWithAuth, patchRequest, postRequest, postRequestWithAuth } from "../configuration";
import getApiWithVersion from "../apis";
import { API_VERSION } from "../../constants/common";
const api = getApiWithVersion(API_VERSION.V1);
export interface Auth{
    postVerifyOtp(data:OtpPayload):Promise<ApiResponse<OtpResponse>>;
    postLogin(data:LoginBody,query:any):Promise<ApiResponse<Login> >;
    postRegister(data:RegisterUserBody):Promise<ApiResponse<RegisterResponse>>;
    postProfileUpdate(data: RegisterUserBody): Promise<ApiResponse<RegisterResponse>>;

    getCheckAuth():Promise<ApiResponse<CheckAuthResponse, AuthError>>
    resendOtp(data: ResendOtpPayload): Promise<ApiResponse<ResendOtpResponse>>;
    patchOtpExpire(data:ResendOtp):Promise<ApiResponse<OtpResponse>>;
      

}

const auth: Auth = {
    postVerifyOtp(data) {
        return postRequest(api.VERIFY_OTP, data)
    },

    postLogin(data,query) {
    return postRequest(api.LOGIN, data, undefined ,query)
    },

    getCheckAuth() {
      return getRequestWithAuth(api.CHECK_AUTH)
  },

    postProfileUpdate(data) {
    return postRequestWithAuth(api.PROFILE_UPDATE, data);
  },

  postRegister(data) {
        return postRequest(api.REGISTER, data)
    },

    resendOtp(data) {
    return postRequest(api.RESEND_OTP, data);
  },

   patchOtpExpire(data){
          return patchRequest(api.RESEND_OTP_EXPIRE, data)
      }
}

export default auth

